<template>
  <article>
    <div :id="index" v-if="!hasToShowStaticTrashBin" class="swiper-container">
      <div class="swiper-wrapper background">
        <template>
          <div class="swiper-slide error trash-bin">
            <span :class="getStaticTrashBinIconClasses">
              remove_shopping_cart
            </span>
          </div>
          <div class="swiper-slide">
            <div class="item">
              <div class="quantity">
                <h5>{{ item.quantity }} x</h5>
              </div>
              <div class="name">
                <h5>{{ item.name }}</h5>
                <p
                  v-if="item.options === undefined || item.options.length === 0"
                >
                  <span :class="getDescriptionClasses">{{
                    item.description
                  }}</span>
                </p>
              </div>
              <div class="price">
                <h5>${{ this.getPrice(item) }}</h5>
              </div>
            </div>
            <div v-for="(op, index) in item.options" :key="index">
              <CheckoutOptionItem :item="op" />
            </div>
          </div>
        </template>
      </div>
    </div>
    <div v-else>
      <div :class="getStaticItemClasses">
        <div :class="getStaticTrashBinClasses" @click="deleteItem">
          <span :class="getStaticTrashBinIconClasses">
            remove_shopping_cart
          </span>
        </div>
        <div class="quantity" @click="restoreBox">
          <h5>{{ item.quantity }} x</h5>
        </div>
        <div class="name" @click="restoreBox">
          <h5>{{ item.name }}</h5>
          <p>{{ item.description }}</p>
        </div>
        <div class="price" @click="restoreBox">
          <h5>${{ this.getPrice(item) }}</h5>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import Swiper from "swiper/dist/js/swiper.js";
import "swiper/dist/css/swiper.css";
import "swiper/dist/js/swiper.js";
import mobile_detection from "../mixins/mobile_detection";
import CheckoutOptionItem from "./CheckoutOptionItem.vue";

export default {
  mixins: [mobile_detection],
  props: {
    index: [Number],
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      swiper: null,
      hasToShowStaticTrashBin: false
    };
  },
  mounted() {
    const self = this;
    const el = "#" + this.index;

    this.swiper = new Swiper(el, {
      initialSlide: 1,
      resistanceRatio: 1,
      speed: 150
    });

    this.swiper.on("progress", function(progress) {
      // self.$emit("transitionEnd");

      if (progress < 0.9 && self.isMobile() === false) {
        self.hasToShowStaticTrashBin = true;
      } else if (progress < 0.6 && self.isMobile()) {
        self.hasToShowStaticTrashBin = true;
      }
    });
  },
  computed: {
    getStaticTrashBinClasses() {
      if (this.isMobile() === false) {
        return "trash-bin-static background";
      } else {
        return "trash-bin-static-mobile background";
      }
    },
    getStaticTrashBinIconClasses() {
      if (this.isMobile() === false) {
        return "material-icons trash-bin-icon";
      } else {
        return "material-icons trash-bin-icon-mobile";
      }
    },
    getStaticItemClasses() {
      if (this.isMobile() === false) {
        return "item";
      } else {
        return "item-mobile";
      }
    },
    getDescriptionClasses() {
      if (this.isMobile() === false) {
        return "descr-desktop";
      } else {
        return "descr-mobile";
      }
    }
  },
  methods: {
    deleteItem() {
      this.$emit("transitionEnd");
      console.log("DELETE ITEM");
      window.location.reload(); ///FIXME: Tengo que encontrar la forma que funcione sin reiniciar la pagina
    },
    restoreBox() {
      window.location.reload(); ///FIXME: Tengo que encontrar la forma que funcione sin reiniciar la pagina
    },
    getPrice(item) {
      return (Math.round(item.totalAmount * 100) / 100).toFixed(2);
    }
  },
  components: {
    CheckoutOptionItem
  }
};
</script>
<style scoped>
.background {
  background-color: #0D6496;
}
.descr-mobile {
  display: block;
  text-align: left;
  font-size: 10px;
  line-height: 14px;
}
.descr-desktop {
  display: block;
  text-align: left;
  font-size: 16px;
}
.item {
  display: flex;
  flex-direction: row;
  color: rgb(39, 50, 57);
  padding: 5vw 4vw 1vw 1vw;
}
.item-mobile {
  display: flex;
  flex-direction: row;
  color: rgb(39, 50, 57);
  padding: 0vw 4vw 0vw 1vw;
}
.quantity {
  width: 10%;
  line-height: 20px;
  font-size: 14px;
  color: rgb(39, 50, 57);
}
.name {
  display: flex;
  flex-direction: column;
  flex: 4 1 0%;
}
.price {
  flex: 1 1 0%;
  text-align: right;
  font-size: 15px;
  line-height: 20px;
}
.name-label {
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  padding-bottom: 4px;
  color: rgb(39, 50, 57);
}
.price-label {
  color: rgb(39, 50, 57);
  width: 100%;
  height: 20px;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: right;
  display: inline-block;
}
.trash-bin {
  padding-top: 3%;
  padding-right: 3%;
  text-align: right;
  color: white;
}
.trash-bin-static {
  padding-top: 4.5vh;
  padding-bottom: 4.5vh;
  padding-right: 3vw;
  padding-left: 4.5vw;
  margin-left: -1vw;
  margin-top: -4.3vh;
  margin-bottom: -4.3vh;
  margin-right: 1vw;
  width: 13vw;
  text-align: right;
  color: white;
  display: flex;
  flex-direction: row;
}
.trash-bin-static-mobile {
  padding-right: 3vw;
  padding-left: 4.5vw;
  padding-top: 1vh;
  padding-bottom: 1vh;
  margin-left: -1vw;
  margin-right: 1vw;
  width: 24vw;
  text-align: right;
  color: white;
  display: flex;
  flex-direction: row;
}
.trash-bin-icon {
  line-height: unset;
  font-size: 4em;
}
.trash-bin-icon-mobile {
  padding-top: 3vh;
  line-height: unset;
  font-size: 4em;
}
</style>



// WEBPACK FOOTER //
// src/Components/SwipeoutItem.vue